const TypeS = () => {
    return (
        <div className="mt-48">
            <div className="mt-10">
                <div className="text-6xl font-thin">به ما</div>
                <div className="text-6xl font-semibold text-gray-900 pt-4">
                    بپیوندید
                </div>
            </div>

            <div className="h-[700px] md:h-[600px] mt-10 md:container md:p-24 ">
                <section className="h-full flex flex-col lg:flex-row">
                    {/* Business Owner Box */}
                    <a
                        className=" md:rounded-[50px_50px_50px_50px]  flex-1 group bg-cover relative flex items-end justify-start mr-1 bg-gray-300 p-8
                    text-white text-2xl font-bold  transition-transform transform hover:cale-x-105 hover:bg-primary w-full"
                        href={"/advertisers"}
                        style={{
                            backgroundImage: `url("/img/bs.jpeg")`,
                            backgroundRepeat: "no-repeat",
                        }}
                    >
                        <div className=" bg-gray-900 md:rounded-[50px_50px_50px_50px] opacity-40 absolute inset-0 group-hover:opacity-0 transition-all"></div>
                        <div className=" w-full flex items-center justify-between text-right">
                            <span className="">
                                کسب و کار دارید ؟
                            </span>
                            <div className="size-8 flex justify-center items-center bg-white group-hover:text-black text-white rounded-xl shadow-xl  p-1 group-hover:-translate-x-2 transition-all">
                                <svg
                                    className="size-6 rotate-180"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 4l8 8-8 8M4 12h16"
                                    />
                                </svg>
                            </div>
                        </div>
                    </a>
                    {/* Driver Box */}
                    <a
                        className=" md:rounded-[50px_50px_50px_50px]  flex-1 group bg-cover relative flex items-end justify-start mr-1 bg-gray-300 p-8
                    text-white text-2xl font-bold  transition-transform transform hover:cale-x-105 hover:bg-primary w-full"
                        href={"/drivers"}
                        style={{
                            backgroundImage: `url("/img/driver.jpg")`,
                            backgroundRepeat: "no-repeat",
                        }}
                    >
                        <div className=" bg-gray-900 md:rounded-[50px_50px_50px_50px] opacity-40 absolute inset-0 group-hover:opacity-0 transition-all"></div>
                        <div className=" w-full flex items-center justify-between">
                            <span className="">
                                راننده هستید ؟
                            </span>
                            <div className="size-8 flex justify-center items-center bg-white group-hover:text-black text-white rounded-xl shadow-xl  p-1 group-hover:-translate-x-2 transition-all">
                                <svg
                                    className="size-6 rotate-180"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 4l8 8-8 8M4 12h16"
                                    />
                                </svg>
                            </div>
                        </div>
                    </a>
                    


                </section>
            </div>
        </div>
    );
};

export default TypeS;
